export default __webpack_public_path__ + "static/TIMBERLINE-L-SERIES-28-D-front-WEB-0dab1455477b8133d215c93075cec879.png";